import React from "react";
import "./ServiceComponents.css";
import PreWedding from "../assets/images/projectimg/bridetobe.jpg";
import PortraitPhotography from "../assets/images/projectimg/portrait.jpg";
import FoodPhotography from "../assets/images/projectimg/food.jpg";

const Photography = () => {
  const projects = [
    {
      id: 1,
      title: "Pre Wedding",
      description: "Bride Pre- Wedding Shoots",
      category: "Wedding",
      image: PreWedding,
      url: "https://www.behance.net/gallery/232189321/Bride-to-be-Photoshoot-(Pre-Wedding-)",
    },

    {
      id: 2,
      title: "Portrait Sessions",
      description: "Professional portrait photography for individuals",
      category: "Portrait",
      image: PortraitPhotography,
      url: "https://www.behance.net/gallery/239856967/Portraits",
    },
    {
      id: 3,
      title: "Food Photography",
      description: "Appetizing food photography for restaurants and brands",
      category: "Commercial, Food",
      image: FoodPhotography,
      url: "https://www.behance.net/gallery/232561369/FOOD-PHOTOGRAPHY",
    },
    // {
    //   id: 6,
    //   title: "Wedding Photography",
    //   description: "Beautiful wedding day coverage and candid moments",
    //   category: "Event",
    //   image: "/images/photo-project6.jpg",
    // },
    // {
    //   id: 7,
    //   title: "Landscape Photography",
    //   description: "Stunning landscape and nature photography",
    //   category: "Nature",
    //   image: "/images/photo-project7.jpg",
    // },
    // {
    //   id: 3,
    //   title: "Corporate Events",
    //   description: "Event coverage for corporate conferences and meetings",
    //   category: "Event",
    //   image: "/images/photo-project2.jpg",
    // },
    // {
    //   id: 4,
    //   title: "Architecture & Real Estate",
    //   description: "Architectural photography for properties and buildings",
    //   category: "Architecture",
    //   image: "/images/photo-project4.jpg",
    // },
    // {
    //   id: 8,
    //   titleR: "Fashion Photography",
    //   description: "Creative fashion shoots for brands and designers",
    //   category: "Fashion",
    //   image: "/images/photo-project8.jpg",
    // },
  ];

  const handleViewProject = (url) => {
    // Open the URL in a new tab
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <div className="service-component">
        <h2 className="service-title">Photography Projects</h2>
        <p className="service-description">
          Capturing moments and creating visual stories through professional
          photography
        </p>

        <div className="projects-grid">
          {projects.map((project) => (
            <div key={project.id} className="project-card">
              <div className="project-image">
                {project.image ? (
                  <img
                    src={project.image}
                    alt={project.title}
                    className="project-img"
                  />
                ) : (
                  <div className="image-placeholder photo-placeholder">
                    <span className="placeholder-text">{project.title}</span>
                  </div>
                )}
              </div>
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-desc">{project.description}</p>
                <div className="project-category">
                  <span className="category-badge">{project.category}</span>
                </div>
                <button
                  className="project-btn"
                  onClick={() => handleViewProject(project.url)}
                  disabled={!project.url} // Disable button if no URL
                >
                  {project.url ? "View Gallery" : "Coming Soon"}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      Stay Tuned for more...
    </>
  );
};

export default Photography;
